import { createTracker } from 'usage-tracker';
export const usageTracker = createTracker({
  standalone: true
});